<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners" v-if="hasPermissionMenu(menuInfo)">  <!-- -->
    <span slot="title">
      <span :class="styles.title">{{ menuInfo.title }}</span>
      <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count }}</span>
      <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i>
    </span>
    <template v-for="item in menuInfo.children">
      <item
        v-if="!item.children && !item.divider && hasPermissionItemMenu(item)"
        :menu-info="item"
        :styles="styles"
        :key="item.key"
      />
      <sub-menu v-if="item.children" :menu-info="item" :styles="styles" :key="item.key" />
    </template>
  </a-sub-menu>
</template>

<script>
import { Menu } from 'ant-design-vue'
import Item from './item'
import { mapGetters } from 'vuex'

export default {
  name: 'SubMenu',
  components: { Item },
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: Object,
    styles: Object,
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  methods: {
    hasPermissionMenu(menu) {
      if (menu.children === undefined || !menu.children) {
        return false
      } else {
        for (const child of menu.children) {
          if (child.permissions === undefined) {
            return true
          } else {
            for (const permission of child.permissions) {
              if (this.user.permissions.includes(permission)) {
                return true
              }
            }
            return true
          }
        }
        return false
      }
    },
    hasPermissionItemMenu(item) {
      if (item.permissions === undefined || !item.permissions) {
        return false
      } else {
        for (const permission of item.permissions) {
          if (this.user.permissions.includes(permission)) {
            return true
          }
        }
        return false
      }
    },
  },
}
</script>
